interface Props {
  message: string;
  missingFields?: string[];
}

export default function PartialInformationWarning({ message, missingFields }: Props) {
  return (
    <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl p-4">
      <div className="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0">
        <i className="ri-information-line text-amber-600 text-sm" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <span className="text-xs font-bold text-amber-800 bg-amber-200/70 px-2 py-0.5 rounded-full">
            INFORMACIÓN PARCIAL
          </span>
        </div>
        <p className="text-sm text-foreground-700 leading-relaxed">{message}</p>
        {missingFields && missingFields.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-1.5">
            {missingFields.map((field) => (
              <span key={field} className="text-xs text-foreground-500 bg-white/60 border border-amber-200 px-2 py-0.5 rounded-full">
                {field}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}